import { createSlice } from "@reduxjs/toolkit";
import { saveBooking } from "./bookingsThunk";

const bookingsSlice = createSlice({
  name: "bookings",
  initialState: {
    email: "",
    cellphone: "",
    country: "",
    name: "",
    totalPrice: 0,
    status: "idle", // To track the loading state
    userBooking: [],
    error: null,
  },
  reducers: {
    setEmail: (state, action) => {
      state.email = action.payload;
    },
    setCellphone: (state, action) => {
      state.cellphone = action.payload;
    },
    setCountry: (state, action) => {
      state.country = action.payload;
    },
    setName: (state, action) => {
      state.name = action.payload;
    },
    setTotalPrice: (state, action) => {
      state.totalPrice = action.payload;
    },
    resetState: (state) => {
      return {
        email: "",
        cellphone: "",
        country: "",
        name: "",
        totalPrice: 0,
        status: "idle",
        userBooking: [],
        error: null,
      };
    },
  },

  extraReducers: (builder) => {
    builder.addCase(saveBooking.fulfilled, (state, action) => {
      // Handle saving the user booking details, update the state as necessary
      const userBookingDetails = action.payload;
      console.log("Booking saved", action.payload);
      state.userBooking.push(userBookingDetails);
      state.status = "bookingSaved";
    });
  },
});

export const {
  setEmail,
  setCellphone,
  setCountry,
  setName,
  setTotalPrice,
  resetState: resetBookingState,
} = bookingsSlice.actions;

export default bookingsSlice.reducer;
